import React from 'react';
import ContentPage from '../components/ContentPage';

export default function AboutPage() {
  return (
    <ContentPage
      pageId="a-propos"
      relatedLinks={[
        { to: '/comment-ca-marche', label: 'Découvrir comment fonctionne Mitonner' },
        { to: '/menus', label: 'Voir les menus' },
        { to: '/avis', label: 'Lire les avis clients' },
        { to: '/contact', label: 'Contacter Mitonner' },
      ]}
    />
  );
}
